import { Injectable } from '@angular/core';
import { BaseServiceWithFilter } from './base.service';
import { WebUser } from '@cl/shared/models/web-users/web-user.model';
import { HttpClient } from '@angular/common/http';
import { CommandResult } from '@cl/shared/models';
import { lastValueFrom } from 'rxjs';
import { WebUserFilter } from '@cl/shared/models/web-users/web-user-filter.model';

@Injectable({
    providedIn: 'root',
})
export class WebUsersService extends BaseServiceWithFilter<WebUser, WebUserFilter> {
    constructor(protected httpClient: HttpClient) {
        super(httpClient, '/api/v1/web-users/');
    }

    addClientToWebUser(webUserId: number, clientId: number): Promise<CommandResult<void>> {
        return lastValueFrom(this.httpClient.post<CommandResult<void>>(`${this.baseApiUrl}web-user/${webUserId}/client/${clientId}`, null));
    }

    deleteWebUserClient(webUserId: number, clientId: number): Promise<CommandResult<void>> {
        return lastValueFrom(this.httpClient.delete<CommandResult<void>>(`${this.baseApiUrl}web-user/${webUserId}/client/${clientId}`));
    }

    async resendWebUserRegistrationInvitation(webUserId: number): Promise<CommandResult<void>> {
        return lastValueFrom(this.httpClient.put<CommandResult<void>>(`${this.baseApiUrl}resend-invitation/${webUserId}`, null));
    }

    async getWebUserByEmail(email: string): Promise<CommandResult<WebUser>> {
        return lastValueFrom(this.httpClient.get<CommandResult<WebUser>>(`${this.baseApiUrl}by-email/${email}`));
    }

    toString(object: WebUser): string {
        return `${object?.login}`;
    }
}
